import { FormLogic } from "./FormLogic";

export const FormContainer = () => {
  return (
    <div>
      <FormLogic />
    </div>
  );
};
